module.exports = __webpack_public_path__ + "img/wxhb.50447302.png";